import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UpsellComponent } from './upsell.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [UpsellComponent],
  exports: [UpsellComponent],
})
export class UpsellModule {}
